import { getModulesQueryBody } from '@tools/ui/consts';
import { Module, Scalars } from '@tools/ui/types/generated/graphql';
import {
  handleSuccessResponse,
  Response
} from '@tools/ui-utils/response-handling.util';
import { axios as api } from './api';

const routePrefix = '/modules';

export const getModules = async (): Promise<{
  data: { moduleMany: Module[] };
}> => {
  return api.post('/graphql', {
    operationName: 'GetModules',
    query: getModulesQueryBody
  });
};

export const createModule = async (
  module: Partial<Module>
): Promise<Response> => {
  return api.post(`${routePrefix}`, module).then(handleSuccessResponse);
};

export const updateModule = async (
  module: Partial<Module>
): Promise<Response> => {
  return api.put(`${routePrefix}`, module).then(handleSuccessResponse);
};

export const deleteModule = async (
  moduleId: Scalars['MongoID']
): Promise<Response> => {
  return api
    .delete(`${routePrefix}`, { data: { _id: moduleId } })
    .then(handleSuccessResponse);
};
